import useGetRetailerReportingAdvertisersTableV3 from '../../../../hooks/use-get-retailer-reporting-advertisers-table-v3'
import useGetRetailerReportingAdvertisersChartV3 from '../../../../hooks/use-get-retailer-reporting-advertisers-chart-v3'

export const getTableAndChartAdvertisersFn = () => {
  const tableFn = useGetRetailerReportingAdvertisersTableV3
  const chartFn = useGetRetailerReportingAdvertisersChartV3

  return { tableFn, chartFn }
}
